import {useSelector} from 'Provider';
import {Text, View} from 'native-base';
import React, {useState} from 'react';

import {StyledPressable} from 'components/Styled';
import ConnectedReservationDates from 'containers/ConnectedReservationDates';
import ConnectedFilterDateSelector from 'containers/DateSelector';
import {threeSoonestValidReservationsSelector} from 'store/reservations/reservations.selectors';
import {useTheme} from 'styled-components/native';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

export interface OfferFilterDatesToggleProps {
  onSelect?: (index: number) => void;
  disabled?: boolean;
  firstTabComponent?: React.ReactElement;
  secondTabComponent?: React.ReactElement;
  isModal?: boolean;
}

const OfferFilterDatesToggle: React.FC<OfferFilterDatesToggleProps> = props => {
  const {
    onSelect,
    disabled = false,
    firstTabComponent = <ConnectedFilterDateSelector />,
    secondTabComponent = <ConnectedReservationDates />,
    isModal = false,
  } = props;

  const reservations = useSelector(threeSoonestValidReservationsSelector);
  const myReservationsTabName = `My Reservations (${reservations.length})`;
  const tabs = ['Date Range', myReservationsTabName];
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const theme = useTheme();
  const {ghostWhite, tuna, transparent} = theme.colors;
  const {trackAdobeEvent} = useTrackEvent();

  const handleToggleClick = (index: number) => {
    if (index === 1) {
      trackAdobeEvent({
        event: AdobeEvent.click,
        click: {
          name: 'rewards filter dates my reservation',
        },
      });
    }

    onSelect && onSelect(index);
    setActiveTabIndex(index);
  };

  return (
    <View
      testID="date-selector"
      flex={!isModal ? undefined : 1}
      marginTop={!isModal ? undefined : 6}
      marginX={!isModal ? 4 : 6}>
      <View
        flexDirection="row"
        height="40px"
        backgroundColor={ghostWhite}
        borderRadius="4px"
        opacity={disabled ? 0.5 : 1}
        overflow="hidden">
        {tabs.map((tab, index) => (
          <StyledPressable
            key={index}
            onPress={() => handleToggleClick(index)}
            alignItems="center"
            flex={1}
            borderBottomWidth="4px"
            borderBottomColor={index === activeTabIndex ? tuna : transparent}
            disabled={reservations.length === 0 && index === 1}
            justifyContent="center">
            <Text
              fontSize={2}
              color={tuna}
              fontWeight={index === activeTabIndex ? 700 : 400}
              letterSpacing="1px">
              {tab}
            </Text>
          </StyledPressable>
        ))}
      </View>
      {activeTabIndex === 0 ? firstTabComponent : secondTabComponent}
    </View>
  );
};

export default OfferFilterDatesToggle;
